import React, { Component } from "react";
import { Link } from "react-router-dom";
import HeaderNav from "./common/HeaderNav";
import Footer from "./Footer";
import apiCall from "../utils/apiCall";

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      telephone: "",
      company: "",
      message: "",
      error: "",
      success: "",
      loading: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title =
      "Contact VIP Number Studio | Get Your Premium VIP Mobile Numbers";
    document
      .querySelector("meta[name='description']")
      .setAttribute(
        "content",
        "Reach out to VIP Number Studio for inquiries about our exclusive VIP mobile numbers. We're here to assist you in selecting the perfect number that suits your style."
      );
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      error: "",
      success: "",
    });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    const { name, email, telephone, company, message } = this.state;

    if (!name || !email || !message) {
      this.setState({ error: "Please fill in all required fields." });
      return;
    }

    this.setState({ loading: true });

    try {
      const response = await apiCall("REACT_APP_CONTACT_US", "POST", {
        name,
        email,
        telephone,
        company,
        message,
      });

      console.log("API Response:", response);

      if (response && response.success) {
        this.setState({
          name: "",
          email: "",
          telephone: "",
          company: "",
          message: "",
          success: "Message sent successfully!",
          error: "",
        });
      } else {
        this.setState({ error: "Failed to send message. Please try again." });
      }
    } catch (error) {
      console.error("API Error:", error);
      this.setState({ error: "An error occurred. Please try again later." });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const {
      name,
      email,
      telephone,
      company,
      message,
      error,
      success,
      loading,
    } = this.state;

    return (
      <>
        <HeaderNav activeTabName="contactUs" />
        <div className="contact-sec">
          <div className="container-fluid p-0 contact-container">
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "300px",
                overflow: "hidden",
                marginTop: "45px",
                marginBottom: "45px",
              }}
            >
              {/* Background Image */}
              <div
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              ></div>

              {/* Gradient Overlay */}
              <div
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  background: "#000040",
                }}
              ></div>
              {/* Red circular accent */}
              <div
                style={{
                  position: "absolute",
                  width: "300px",
                  height: "300px",
                  backgroundColor: "rgba(255, 0, 0, 0.8)",
                  borderRadius: "50%",
                  top: "-150px",
                  right: "-100px",
                  zIndex: 1,
                }}
              ></div>

              {/* Second red circular accent */}
              <div
                style={{
                  position: "absolute",
                  width: "150px",
                  height: "150px",
                  backgroundColor: "rgba(255, 0, 0, 0.8)",
                  borderRadius: "50%",
                  bottom: "-70px",
                  left: "50px",
                  zIndex: 1,
                }}
              ></div>

              {/* Decorative dots */}
              <div
                style={{
                  position: "absolute",
                  top: "20px",
                  left: "20px",
                  display: "flex",
                  gap: "5px",
                }}
              >
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                  }}
                ></div>
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                  }}
                ></div>
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                  }}
                ></div>
              </div>

              {/* Decorative triangle */}
              <div
                style={{
                  position: "absolute",
                  bottom: "15px",
                  right: "60px",
                  width: 0,
                  height: 0,
                  borderLeft: "15px solid transparent",
                  borderRight: "15px solid transparent",
                  borderBottom: "26px solid rgba(255, 255, 255, 0.15)",
                  transform: "rotate(45deg)",
                }}
              ></div>

              {/* Content Container */}
              <div
                style={{
                  position: "relative",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "0 20px",
                  zIndex: "2",
                }}
              >
                <h1
                  style={{
                    color: "white",
                    fontSize: "42px",
                    fontWeight: "800",
                    marginBottom: "16px",
                    textAlign: "center",
                    textShadow: "2px 2px 8px rgba(0, 0, 0, 0.6)",
                  }}
                >
                  Contact Us
                </h1>

                <p
                  style={{
                    color: "white",
                    fontSize: "18px",
                    fontWeight: "400",
                    maxWidth: "700px",
                    textAlign: "center",
                    textShadow: "1px 1px 4px rgba(0, 0, 0, 0.8)",
                  }}
                >
                  Reach out to VIP Number Studio for inquiries about our
                  exclusive VIP mobile numbers.
                </p>

                {/* Decorative Line */}
                <div
                  style={{
                    width: "80px",
                    height: "4px",
                    background:
                      "linear-gradient(90deg,rgba(255, 255, 255, 0.74), rgb(233, 2, 2))",
                    marginTop: "20px",
                    borderRadius: "2px",
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div className="support-sec">
          <div className="container support-container">
            <div className="row support-row">
              <div className="col-md-6 col-sm-12">
                <h2 className="support-txt my-3">Contact VIP Number Studio</h2>
                <ul className="support-list">
                  <li>
                    <i className="fas fa-map-marker-alt"></i> VIP NUMBER STUDIO
                  </li>
                  <li>
                    Shop No.2 Mahape Road opp. Regal Restaurant Shilphata
                    Thane-421204
                  </li>
                  <li>
                    <i className="fas fa-phone-alt"></i>
                    <a
                      className="contact-link contact-no"
                      href="tel:+918562944944"
                    >
                      8562 944 944
                    </a>
                  </li>
                  <li>
                    <i className="fas fa-envelope"></i>
                    <a
                      className="contact-link mail-id"
                      href="mailto:info@vipnumberstudio.com"
                    >
                      info@vipnumberstudio.com
                    </a>
                  </li>
                </ul>
                <hr />
                <h4 className="followus-txt left">Follow Us</h4>
                <ul className="icon-list">
                  <li>
                    <a href="http://instagram.com/vipnumberstudio">
                      <i className="fab fa-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-md-6 col-sm-12 boxshadow p-3 form-detail">
                <form onSubmit={this.handleSubmit}>
                  {error && <p className="alert alert-danger">{error}</p>}
                  {success && <p className="alert alert-success">{success}</p>}
                  <div className="row my-2">
                    <div className="col-md-6 col-sm-12">
                      <label>Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={name}
                        onChange={this.handleChange}
                      />
                    </div>
                    <div className="col-md-6 col-sm-12">
                      <label>Email</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={email}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                  <div className="row my-2">
                    <div className="col-md-6 col-sm-12">
                      <label>Telephone</label>
                      <input
                        type="text"
                        className="form-control"
                        name="telephone"
                        value={telephone}
                        onChange={this.handleChange}
                      />
                    </div>
                    <div className="col-md-6 col-sm-12">
                      <label>Company Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="company"
                        value={company}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                  <div className="row my-2">
                    <div className="col-md-12 col-sm-12">
                      <label>Message</label>
                      <textarea
                        className="form-control"
                        name="message"
                        value={message}
                        onChange={this.handleChange}
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-md-12 col-sm-12 my-3">
                    <button
                      type="submit"
                      className="btn-send"
                      disabled={loading}
                    >
                      {loading ? "Sending..." : "Send your message"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default Contact;
